module.exports = __webpack_public_path__ + "./fonts/SourceSansProBold.otf";